import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../session-storage/session-storage.service';
import { CreateNewUser } from '../../models/create-new-user/create-new-user.model';
import { environment } from '../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async getUserList() {
    const API_URL: string = environment.baseUrl + environment.apis.getUserList;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        useremail: this.sessionStorageService.getCurrentUserEmail()
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  async createNewUser(createNewUser: CreateNewUser) {
    const API_URL: string = environment.baseUrl + environment.apis.createNewUser;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: createNewUser.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

}
